<template lang='pug'>
  //- Privacy-Page
  div(:class='$style[`cc-footer-privacy`]')
    div(:class='$style[`cc-privacy-banner`]')
      div(:class='$style[`cc-banner-title`]')
        span.font-bold(:class='$style[`cc-banner-main-title`]')
          span.font-doctor-theme(v-html='`隱`')
          span.font-normal-theme(v-html='`私`')
          span.no-wrap(v-html='`政策`')

    div(:class='$style[`cc-privacy-container`]')
      div(:class='$style[`cc-privacy-container-wrap`]')
        div(:class='$style[`cc-privacy-container-wrap-list`]')
          h1.font-medium!= '一、隱私權聲明'
          div(:class='$style[`cc-privacy-info`]')
            span!= '歡迎使用Cancell的網站，為了保障您的權益，使用本網站前，請先詳讀本隱私權政策與使用條款，將說明如何蒐集、儲存、處理、移轉及使用您的個人資料。在使用本網站將傳送您的個人資料予Cancell存取或使用、或以其他方式存取、使用任何Cancell服務時，即表示您同意以本隱私權政策聲明所述方式處理您的個人資料。'


        div(:class='$style[`cc-privacy-container-wrap-list`]')
          h1.font-medium!= '二、本政策適用範圍'
          div(:class='$style[`cc-privacy-info`]')
            span!= '本政策適用Cancell所有服務請<sup class="font-normal-theme">1</sup>。我們可能不定時推出新服務。若推出新服務使收集與使用個人資料的方式有變動，我們會提供變動的項目。除非推出的新服務有特別說明，否則這類服務仍須遵守本政策。'
            span.font-normal-theme!= '1. Cancell服務提供，發表留言或提問、精選文章分類、內容註冊會員(醫生及使用者)、分享個人癌友故事卡、個人喜好標籤、報名活動、醫生及使用者投稿、追隨醫生、醫生文章認同。'


        div(:class='$style[`cc-privacy-container-wrap-list`]')
          h1.font-medium!= '三、個人資料蒐集管理及利用方式'
          div(:class='$style[`cc-privacy-info`]')
            span!= '蒐集目的：Cancell基於使用者、管理與服務、行銷與廣告業務、統計及研究分析，使用下列式收集個人資料。'
            span.font-bold
              span(:class='$style[`cc-privacy-sub-info`]')!= '1. 蒐集個人資料類別：'
            ul
              li!= 'Cancell於網站內蒐集的個人資料包括：'
              li!= '辨識個人者： 包括不限於會員之姓名、地址、電話、電子郵件、個人癌友故事卡、醫生個人工作地點等資訊。'
              li!= '個人描述：包括不限於性別、出生年月日等。'
              li!= '如有其他個資項目蒐集，Cancell將另以其他方式通知並取得同意。'
            span!= '以上所實際蒐集之資料類別依註冊或使用時所要求提供之個人資料類別為準。'


            span.font-bold
              span(:class='$style[`cc-privacy-sub-info`]')!= '2. 資料搜集方式：'
            ul
              li!= '當您瀏覽網站時	，將收集您瀏覽網站的使用情形，例如閱讀哪些文章、關注哪位醫生、在哪些地方離開網頁、閱讀日期與時間、Cookie 資料、您的 IP 位址、瀏覽器類型、連線至網站的裝置類型。'
              li!= '當您註冊會員時 - 我們會收集您的個人資料，例如：姓名、電子信箱、手機、喜好標籤，以便為您提供會員服務。'
              li!= '當您投稿時 - 我們會收集您的個人資料，例如：姓名、電子信箱、手機、個人照片、職業、著作、身分證統一編號、匯款資料，以便與您聯絡投稿事宜、編輯文稿、處理稿費與投寄贈書。'
              li!= '來自第三方 - 我們會從與我們合作的第三方，包括廣告商與合作夥伴，收集到有關您的個人資料。只有當您同意第三方或Cancell進行資料分享、或註冊會員時，才會使用。'


            span.font-bold
              span(:class='$style[`cc-privacy-sub-info`]')!= '3. Cookie技術與使用：'
            ul
              li!= 'cookie是網站伺服器用來和使用者瀏覽器進行溝通的一種技術，它可能在使用者的電腦中儲存某些資訊，但是使用者可以自由經由瀏覽器的設定，取消、或限制此項功能。'
              li!= '為了便利使用者，Cancell將使用cookie技術，以利本網站進行網站活動之各種分析、資訊收集，並提供更適合使用者需要的服務；Cancell將Cookie 以安全的方式提供給數據部門或外部的數據服務業者將您的使用資訊和軌跡進行有效的整合分析，使Cancell能更瞭解使用者的需求和喜好。'
              li!= 'Cancell尊重您對於個人資料應用領域的意願，依照相關規範，Cancell提供您自由選擇是否願意將個人資料作為本隱私權政策所提及之應用。若您不願意將個人資料(包括但不限於cookie等)提供予「Cancell」作相關利用，您可採取以下措施：'
                span.font-bold!= '• 如您不希望接受Cancell使用cookie，請自行利用瀏覽器的設定，關閉cookie追蹤功能，但此舉可能造成使用者在使用Cancell部分服務或參與活動時受到限制。'
                span.font-bold!= '• 若您希望刪除已蒐集cookie或其他個人識別資料，歡迎以電子郵件連絡。'
              li!= 'Cancell的 Cookie 來源可能是第一方或第三方 Cookie。Cookie 是「第一」方或「第三」方 Cookie，視放置Cookie 的網站或網域而定。在本 Cookie 政策所稱的第一方 Cookie是指Cancell設置的 Cookie，Cancell接收此類 Cookie 蒐集的所有資訊，而第三方 Cookie 則是由Cancell業務往來的其他方設置。當您造訪Cancell的網站時，上述相關方可能會在您的瀏覽器上放置Cookie，蒐集有關您對網站的使用情況與可能的其他活動，以及不同網站與應用程式之資訊。我們會要求第三方cookie放置方在資訊之蒐集、利用及處理應符合相關法律規定，第三方cookie資料之蒐集、利用及處理，須以該第三方之隱私權政策為準。'


            span.font-bold
              span(:class='$style[`cc-privacy-sub-info`]')!= '4. 利用期間、地區：'
            ul
              li!= '期間：您要求停止使用Cancell服務之日止。'
              li!= '地區：您的個人資料將用於台灣地區及與Cancell有業務往來之所在地。'


            span.font-bold
              span(:class='$style[`cc-privacy-sub-info`]')!= '5. 利用對象及方式：'
            ul
              li!= '個人化的服務，我們會用個人資料，為您打造個人化服務，包括個人化內容或建議活動、建議文章。例如：若是有勾選肺癌標籤，我們將優先提供您肺癌相關文章。'
              li!= '評估成效 - 為了了解本服務的使用情形，我們會收集並分析資料。我們會運用Google Analytics（分析）等多種工具分析，而這些分析結果將用來改善服務，為您提供更佳的內容。'
              li!= '保護Cancell使用者和一般大眾 - 我們會應用相關資料來改善Cancell服務的穩定與安全。包括：偵測與預防可能造成Cancell使用者傷害的濫用行為、安全性風險，並做出回應。'


        div(:class='$style[`cc-privacy-container-wrap-list`]')
          h1.font-medium!= '四、分享您的個人資料'
          div(:class='$style[`cc-privacy-info`]')
            span!= '以下個人資料，將會公開顯示：'
            ul
              li!= '醫生及一般使用者投稿：在Cancell網站編寫文章，一經錄用將刊登在網站，姓名、身分、著作將經您同意分享的情況下，公開於投稿的文章上。一般使用者可自行選擇不公開您投稿的文章。'
              li!= '社群互動交流：在第三方服務註冊帳戶時（例如Facebook , Google），第三方服務會要求您建立特定的使用者名稱，依據您分享給第三方服務資料不同，所有使用Cancell服務的人都看得到這個名稱以及您所張貼的任何評論。'
              li!= '病患故事卡(個人抗癌心路歷程)：若你在Cancell網站使用故事卡功能，在經您同意將會顯示在所有使用Cancell服務會員。'

            span!= '我們可能會分享的資訊：'
            ul
              li!= '服務供應商：我們會與提供技術基礎架構的服務供應商合作，尤其是代管、儲存、管理及維護Cancell網站程式、內容以及我們所處理的資料的供應商，已便Cancell所有服務順利運作。'
              li!= '合作夥伴 <a class="font-normal-theme" href="#">Cancell合作廠商列表</a>：依據您註冊Cancell服務的方式，例如透過第三方服務(Google , Facebook)，我們會視需要分享您的使用者名稱，或其他帳戶註冊資料以啟用您的帳戶。'
              li!= '執法機關：為了遵守法律義務，對搜查令、法院命令或傳票等有效的法律程序作出回應，我們將會分享您的個人資料。'
              li!= '網站互動服務上(例如：討論板或留言板等)，可自由填寫任何資訊。此資訊若被其他有心人士利用，此類行為非本網站所能控制，若造成使用者困擾，使用者將會負責自己的發言並負擔所有法律責任，「Cancell」網站並不對此負責。'
              li!= '「Cancell」網站為服務使用者，在部分網頁中會提供相關網站連結，使用者可藉由連結，直接點選到感興趣的網站，但是本網站不負責這些經由本網站而連結到外部的網站中的隱私權。'
              li!= '外站連結：「Cancell」相關網站或網頁都可能包含其他網站或網頁的連結，對於此等不屬於「Cancell」網站，本政策不適用於該網站。'


        div(:class='$style[`cc-privacy-container-wrap-list`]')
          h1.font-medium!= '五、您的個人資料保存、刪除和權利'
          div(:class='$style[`cc-privacy-info`]')
            span!= '依個人資料保護法可以與Cancell聯絡請求行使以下權利：'
            ul
              li!= '查詢或請求閱覽。'
              li!= '複製。'
              li!= '補充或更正。'
              li!= '請求停止搜集、處理或利用。'
              li!= '請求刪除。'
            span!= '上述權利之行使，Cancell可能依法酌收必要成本費用，若因不符合申請程序、法律規定、本網站依法負有保存義務或法律另有規定之情況者，則可能無法依您的要求辦理。'

        div(:class='$style[`cc-privacy-container-wrap-list`]')
          h1.font-medium!= '六、隱私群政策的異動'
          div(:class='$style[`cc-privacy-info`]')
            span!= '這份政策保障自本網站成立起即生效，但因應社會環境及法令規定的變遷，若「Cancell」網站為保護網友隱私，認為需要修改這份聲明，會在最短的時間內更新。如果您對「Cancell」網站的隱私權政策或與會員使用條款有任何疑問，歡迎您以電子郵件與「Cancell」連絡。'

        div(:class='$style[`cc-privacy-container-wrap-list`]')
          h1.font-medium!= '七、與我們聯絡'
          div(:class='$style[`cc-privacy-info`]')
            span!= '如果您對Cancell服務或本協議有疑問，請利用以下方式與Cancell聯絡：'
            ul
              li.font-normal-theme!= '服務時間：週一～週五：10:00 - 18:00'
              li.font-normal-theme!= '服務信箱：'
                a.font-normal-theme(href='mailto:service@cancell.tw' target='_blank')!= 'service@cancell.tw'
              li.font-normal-theme!= '臉書粉絲專頁：'
                a.font-normal-theme(href='https://www.facebook.com/cancelltw' target='_blank')!= '@cancelltw'
              li.font-normal-theme!= '官方Line：'
                a.font-normal-theme(href='https://lin.ee/lnARn5f' target='_blank')!= 'https://lin.ee/lnARn5f'
            span!= '感謝您閱讀此條款。希望您盡情享受Cancell所提供的服務！'


</template>

<script>
export default {
  metaInfo() {
    return {
      title: '隱私政策',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/privacy',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/privacy',
      }],
    };
  },

  // data () {
  //   return {
  //   }
  // },

  // methods: {},
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/footer/privacy.scss';
</style>
